import React from "react"
import Icon from '@ant-design/icons';

function IconSvg()
{
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ stroke: "currentcolor" }} xmlns="http://www.w3.org/2000/svg">
      <g id="Component 88">
        <path id="Vector" d="M2.5 5H4.16667H17.5" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Vector_2" d="M6.6665 4.99996V3.33329C6.6665 2.89127 6.8421 2.46734 7.15466 2.15478C7.46722 1.84222 7.89114 1.66663 8.33317 1.66663H11.6665C12.1085 1.66663 12.5325 1.84222 12.845 2.15478C13.1576 2.46734 13.3332 2.89127 13.3332 3.33329V4.99996M15.8332 4.99996V16.6666C15.8332 17.1087 15.6576 17.5326 15.345 17.8451C15.0325 18.1577 14.6085 18.3333 14.1665 18.3333H5.83317C5.39114 18.3333 4.96722 18.1577 4.65466 17.8451C4.3421 17.5326 4.1665 17.1087 4.1665 16.6666V4.99996H15.8332Z" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Vector_3" d="M8.3335 9.16663V14.1666" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path id="Vector_4" d="M11.6665 9.16663V14.1666" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export function IconDelete(props)
{
  return <Icon component={IconSvg} {...props} />
}




